export default __webpack_public_path__ + "static/karriere-64119bde544a5242bfbff6cd524aaa74.webp";